<template>
    <dialog-template
        :width="'621px'"
        :headerTitle="'零售版本与定价'"
        :visible.sync="isShow"
        @close="() => { isLoading = false; $emit('close') }">
        <div class="fx new-renew"
            v-loading="isLoading">
            <ul class="new-renew__left">
                <li v-for="(item, index) in types"
                    class="fx-v-center color-333 fs-16 fw-600"
                    :class="{
                        'is-recommend': item.isRecommend,
                        'active': index === curActiveIndex
                    }"
                    :key="item.name"
                    @click="switchIndex(index)">
                    <div class="edition-icon mr-5">
                        <img :src="item.icon" :alt="item.name">
                    </div>
                    <div class="title">{{ item.name }}</div>
                </li>
                <div class="href-wrapper align-c">
                    <!-- <p v-if="isShiYong"
                        class="href fs-12"
                        @click="openActivateCodeWithGetShopInfo">商米激活码兑换</p> -->
                    <p v-if="true" @click="jumpToVersionPage"  class="href fs-12" >查看不同版本对比</p>
                </div>
            </ul>
            <div class="new-renew__right">
                <renew-item :type="curActiveIndex" :renewPayInfo="renewPayInfo" />
            </div>
        </div>
    </dialog-template>
</template>

<script lang="tsx">
import { createComponent, ref, onBeforeMount, onMounted, computed, onBeforeUnmount } from '@vue/composition-api'
import RenewItem from './components/renew_item.vue'
import { openMessage } from '../../utils/system'
import $fetch from '../../api'
import { editionJudge } from '../../utils/editionJudge'
import { useStore } from '../../store'
import { openActivateCodeWithGetShopInfo } from '@/components/activate_code/activate_code.tsx'
import clone from 'lodash/cloneDeep'

export interface IFee {
    id: number
    fee_code: number
    price: string
    status: number,
    expired_date_info: any[]

}

export interface IRenewPayInfo {
    biaozhunServiceFee: IFee
    biaozhunBuyFee: IFee
    zhuanyeServiceFee: IFee
    zhuanyeBuyFee: IFee
    qijianServiceFee: IFee
    qijianBuyFee: IFee,
    activityInfo: {
        detail_info: any[],
        start_time: string,
        end_time: string,
        status: number
    }
}

export default createComponent({
    setup: (props, ctx) => {
        const isShow = ref(false)
        const isLoading = ref(false)
        const renewPayInfo = ref<IRenewPayInfo>({
            biaozhunServiceFee: {
                id: 2,
                fee_code: 1002,
                price: "0.0100",
                status: 1,
                expired_date_info: []
            },
            biaozhunBuyFee: {
                id: 15,
                fee_code: 1015,
                price: "0.0100",
                status: 1,
                expired_date_info: []
            },
            zhuanyeServiceFee: {
                id: 3,
                fee_code: 1003,
                price: "0.0100",
                status: 1,
                expired_date_info: []
            },
            zhuanyeBuyFee: {
                id: 16,
                fee_code: 1016,
                price: "0.0100",
                status: 1,
                expired_date_info: []
            },
            qijianServiceFee: {
                id: 4,
                fee_code: 1004,
                price: "0.0100",
                status: 1,
                expired_date_info: []
            },
            qijianBuyFee: {
                id: 17,
                fee_code: 1017,
                price: "0.0100",
                status: 1,
                expired_date_info: []
            },
            activityInfo: {
                detail_info: [],
                start_time: '',
                end_time: '',
                status: 0,
                expired_date_info: []
            }
        })
        const curActiveIndex = ref(editionJudge.getShopVersion)

        const types = computed(() => {
            return [{
                name: '标准版',
                icon: require('./images/biaozhun.svg'),
                // bg: 'linear-gradient(90deg, #14CC9B 0%, #14CC7A 100%)',
                isRecommend: false
            }, {
                name: '专业版',
                icon: require('./images/zhuanye.svg'),
                // bg: 'linear-gradient(90deg, #ECB161 0%, #F1C774 100%)',
                isRecommend: true
            }, {
                name: '旗舰版',
                icon: require('./images/qijian.svg'),
                // bg: 'linear-gradient(-46deg, #65503E 0%, #2A2825 100%)',
                isRecommend: false
            }]
        })

        const isShiYong = computed(() => {
            return editionJudge.isShiYong
        })

        onBeforeMount(() => {
            isLoading.value = true
            getShopRenewAlpayInfo()
                .then(() => isLoading.value = false)
        })

        async function getShopRenewAlpayInfo() {
            try {
                const result = await $fetch.post({
                    url: "/valueaddedservices/shoprenewalpayinfo"
                })
                console.log('店铺续费信息', clone(result))
                const biaozhunServiceFee = result.fee_infos.find(item => item.fee_code === 1002) as IFee
                const biaozhunBuyFee = result.fee_infos.find(item => item.fee_code === 1015) as IFee
                const zhuanyeServiceFee = result.fee_infos.find(item => item.fee_code === 1003) as IFee
                const zhuanyeBuyFee = result.fee_infos.find(item => item.fee_code === 1016) as IFee
                const qijianServiceFee = result.fee_infos.find(item => item.fee_code === 1004) as IFee
                const qijianBuyFee = result.fee_infos.find(item => item.fee_code === 1017) as IFee

                console.dir(biaozhunServiceFee)
                renewPayInfo.value = {
                    biaozhunServiceFee,
                    biaozhunBuyFee,
                    zhuanyeServiceFee,
                    zhuanyeBuyFee,
                    qijianServiceFee,
                    qijianBuyFee,
                    activityInfo: result.activity_infos[0]
                }
            } catch (e) {
                openMessage('error', e.message || '获取店铺支付信息失败')
            }
        }

        function open() {
            isShow.value = true
        }

        function close() {
            isShow.value = false
        }

        function switchIndex(i) {
            if (curActiveIndex.value === i) {
                return
            }
            curActiveIndex.value = i
        }

        function jumpToVersionPage() {
            window.location.href = 'https://i.senguo.cc/bbs/detail/19f329dc9100ca98'
        }

        return {
            // data
            isShow,
            isLoading,
            isShiYong,
            curActiveIndex,
            renewPayInfo,
            // computed
            types,
            // methods
            open,
            close,
            switchIndex,
            openActivateCodeWithGetShopInfo,
            jumpToVersionPage
        }
    },

    components: {
        RenewItem
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-dialog div.el-dialog__body {
    padding: 0;
}

.new-renew {
    height: 338px;

    &__left {
        position: relative;
        flex: 0 0 117px;
        border-right: 1px solid #F2F2F2;
        box-sizing: border-box;

        li {
            height: 50px;
            padding: 0 16px;
            transition: all .25s;
            cursor: pointer;

            &.active {
                background-color: #F2F2F2;
            }

            &.is-recommend .title {
                position: relative;

                &::before {
                    content: '荐';
                    position: absolute;
                    right: -17px;
                    top: -8px;
                    width: 17px;
                    height: 17px;
                    line-height: 17px;
                    border-radius: 50%;
                    text-align: center;
                    font-size: 12px;
                    font-weight: normal;
                    background-color: #E3212C;
                    color: #fff;
                }
            }

            &:first-of-type {
                margin-top: 12px;
            }

            &:hover {
                background-color: #F2F2F2;
            }

            .edition-icon {
                width: 16px;
                height: 16px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .href-wrapper {
            position: absolute;
            bottom: 32px;
            width: 100%;
            text-align: center;

            p:nth-child(n + 2) {
                padding-top: 12px;
            }
        }
    }

    &__right {
        flex: 1;
    }
}
</style>
